export { default as DECLINATION_QUERY } from "./declination_query";
export { default as SEO_QUERY } from "./seo_query";
